// extracted by mini-css-extract-plugin
export default {"landing-bg":"LoadingBg_landing-bg__xC-wl","logo-container":"LoadingBg_logo-container__RvRrt","big-logo":"LoadingBg_big-logo__dFy8J","small-logo":"LoadingBg_small-logo__zV+I6"};